import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    // Address strings (for input fields)
    pickupAddress: '',
    dropoffAddress: '',

    // Geographic coordinates (for map)
    pickupCoords: null,
    dropoffCoords: null,

    // Map display
    currentLocation: null,  // For map center
    locationError: null,

    // Autocomplete
    suggestions: [],
    currentField: null,     // 'pickup' or 'dropoff'
};

const locationSlice = createSlice({
    name: 'location',
    initialState,
    reducers: {
        // For address input changes
        setPickupAddress: (state, action) => {
            state.pickupAddress = action.payload;
        },
        setDropoffAddress: (state, action) => {
            state.dropoffAddress = action.payload;
        },

        // For coordinate updates
        setPickupCoords: (state, action) => {
            state.pickupCoords = action.payload;
        },
        setDropoffCoords: (state, action) => {
            state.dropoffCoords = action.payload;
        },

        // For map interactions
        setCurrentLocation: (state, action) => {
            state.currentLocation = action.payload;
        },
        setLocationError: (state, action) => {
            state.locationError = action.payload;
        },

        // For autocomplete
        setSuggestions: (state, action) => {
            state.suggestions = action.payload;
        },
        setCurrentField: (state, action) => {
            state.currentField = action.payload;
        },
        clearSuggestions: (state) => {
            state.suggestions = [];
        },

        setCompletePickupLocation: {
            reducer(state, action) {
                state.pickupAddress = action.payload.address;
                state.pickupCoords = action.payload.coords;
            },
            prepare(address, coords) {
                return {
                    payload: {
                        address,
                        coords: {
                            lat: coords.lat,
                            lng: coords.lng
                        }
                    }
                };
            }
        },
        setCompleteDropoffLocation: {
            reducer(state, action) {
                state.dropoffAddress = action.payload.address;
                state.dropoffCoords = action.payload.coords;
            },
            prepare(address, coords) {
                return {
                    payload: {
                        address,
                        coords: {
                            lat: coords.lat,
                            lng: coords.lng
                        }
                    }
                };
            }
        }
    },
});

export const {
    setPickupAddress,
    setDropoffAddress,
    setPickupCoords,
    setDropoffCoords,
    setSuggestions,
    setCurrentField,
    setCurrentLocation,
    setLocationError,
    clearSuggestions,
    setCompletePickupLocation,
    setCompleteDropoffLocation
} = locationSlice.actions;

export default locationSlice.reducer;